/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'confluence-table-tree.column.contributors': 'Учасники',
  'confluence-table-tree.column.last-modified': 'Остання зміна',
  'confluence-table-tree.column.title': 'Ім’я',
  'confluence-table-tree.could-not-load': 'Не вдалося завантажити',
  'confluence-table-tree.could-not-load-contributors': 'Не вдалося завантажити авторів',
  'confluence-table-tree.create-child-page': 'Створити дочірню сторінку',
  'confluence-table-tree.create-page': 'Створити сторінку',
  'confluence-table-tree.default.page.title': 'Без назви',
  'confluence-table-tree.default.show-all-pages-button.label': 'Показати більше сторінок',
  'confluence-table-tree.draft.lozenge': 'ЧЕРНЕТКА',
  'confluence-table-tree.draft.tooltip': 'Чернетки можете бачити тільки ви.',
  'confluence-table-tree.drafts-toggle.label': 'Показати чернетки',
  'confluence-table-tree.edit': 'Редагувати',
  'confluence-table-tree.edit-in-confluence': 'Редагувати в Confluence',
  'confluence-table-tree.empty.description':
    'Щоб заповнити цей розділ, додайте в нього примітки до наради, вимоги до продукту, рішення чи інший вміст.',
  'confluence-table-tree.empty.title': 'Тут багато можливостей',
  'confluence-table-tree.error.description': 'Не можна відобразити ці сторінки. Повторіть спробу пізніше.',
  'confluence-table-tree.error.row': 'Не вдалося завантажити сторінки.',
  'confluence-table-tree.error.title': 'Щось пішло не за планом...',
  'confluence-table-tree.friendly-when-created': 'Створено',
  'confluence-table-tree.friendly-when-updated': 'Змінено',
  'confluence-table-tree.share.copied': 'Скопійовано в буфер обміну',
  'confluence-table-tree.share.copy-button': 'Копіювати',
  'confluence-table-tree.share.subtitle': 'Поділитися цим посиланням',
  'confluence-table-tree.share.title': 'Поділитися сторінкою',
  'confluence-table-tree.share.tooltip': 'Поділитися',
  'confluence-table-tree.view-profile': 'Переглянути профіль',
};
